import { Footer } from './components/layout/Footer';
import { Navbar } from './components/layout/Navbar';
import { About } from './sections/About';
import { Hero } from './sections/Hero';
import { Services } from './sections/Services';
import { SuccessStories } from './sections/SuccessStories';

const App = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <Services />
      <SuccessStories />
      <About />
    </main>
    <Footer />
  </>
);

export default App;
